import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { Boat } from '../l_admin/boat.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BoatService {

  private apiUrl = environment.apiUrl; // Replace with your actual API endpoint

  constructor(private http: HttpClient) {}

  // getBoatByKategori(boat_kategori: any = []): Observable<any> {
  //   return this.http.get(`${this.apiUrl}/kapal/boatkategori/${boat_kategori}`);
  // }

  getBoatByKategori(boat_kategori: string, trip_kategori?: string): Observable<any> {
    let params = new HttpParams();

    // Jika trip_kategori disediakan, tambahkan ke query parameters
    if (trip_kategori) {
      params = params.set('trip_kategori', trip_kategori);
    }

    // Panggilan ke endpoint backend
    return this.http.get<any>(`/api/kapal/boatkategori/${boat_kategori}`, { params });
  }

  getBoatByTujuan(tujuan: string, tripKategori?: string): Observable<any> {
    let params = new HttpParams().set('tujuan', tujuan);
    if (tripKategori) {
      params = params.set('trip_kategori', tripKategori);
    }

    return this.http.get<any>(`/api/kapal`, { params });
  }

  getBoatOpen( tripKategori?: string): Observable<any> {
    let params = new HttpParams();
    if (tripKategori) {
      params = params.set('trip_kategori', tripKategori);
    }

    return this.http.get<any>(`/api/kapal`, { params });
  }


  getBoatOpenLite( tripKategori?: string): Observable<any> {
    let params = new HttpParams();
    if (tripKategori) {
      params = params.set('trip_kategori', tripKategori);
    }

    return this.http.get<any>(`/api/kapallite`, { params });
  }


  getFeat(tripKategori: string, page: number = 1, limit: number = 10): Observable<any> {
    return this.http.get<any>(`/api/kapalfeat`, {
      params: { trip_kategori: tripKategori, page, limit }
    });
  }

  getFeat2(tripKategori?: string): Observable<any> {
    let params = new HttpParams();
    if (tripKategori) {
      params = params.set('trip_kategori', tripKategori);
    }
    return this.http.get<any>(`/api/kapalfeat2`, { params });
  }


  cariKapal(keyword: string): Observable<any> {
    return this.http.post<any>(`/api/carikapal`, { search: keyword });
  }

  filterKapalLite(filters: {
    nama_kapal?: string;
    trip_kategori?: string[]; // Array of kategori
    boat_kategori?: string | string[];
    tujuan?: string | string[];
    date_from?: string;
    date_to?: string;
    min_price?: number;
    max_price?: number;
    sort?: string;
    page?: number;
    limit?: number;
  }): Observable<any> {
    let params = new HttpParams();

    if (filters.nama_kapal) {
      params = params.set('nama_kapal', filters.nama_kapal);
    }

    if (filters.trip_kategori && filters.trip_kategori.length > 0) {
      filters.trip_kategori.forEach(kategori => {
        params = params.append('trip_kategori', kategori); // array support
      });
    }

    if (filters.boat_kategori) {
      (Array.isArray(filters.boat_kategori) ? filters.boat_kategori : [filters.boat_kategori]).forEach(value => { params = params.append('boat_kategori', value); });
    }

    if (filters.tujuan) {
      (Array.isArray(filters.tujuan) ? filters.tujuan : [filters.tujuan]).forEach(value => { params = params.append('tujuan', value); });
    }

    if (filters.page) {
      params = params.set('page', filters.page.toString());
    }

    if (filters.limit) {
      params = params.set('limit', filters.limit.toString());
    }

    (['date_from', 'date_to', 'min_price', 'max_price', 'sort'] as const).forEach(key => {
      if (filters[key] != null && filters[key] !== '') params = params.set(key, String(filters[key]));
    });
    return this.http.get<any>(`/api/filter-lite`, { params }).pipe(map(response => {
      // Older API deployments silently ignore date filters. Never present their
      // catalog response as confirmed availability for the selected dates.
      if (filters.date_from && (
        response.availability_granularity !== 'date' ||
        !Array.isArray(response.items) ||
        response.items.some((boat: any) => !Array.isArray(boat.available_schedules) || !boat.available_schedules.length)
      )) {
        throw new HttpErrorResponse({
          status: 503,
          error: {
            code: 'AVAILABILITY_UNVERIFIED',
            message: 'We couldn’t verify availability for these dates. Please try again shortly.'
          }
        });
      }
      return response;
    }));
  }

}
